import React from 'react';
import { FailureStatus } from 'src/common/ui/StatusScreen';
import { useTranslation } from 'src/i18n/shim/useTranslation';

/**
 * Page shown when the bootstrap cannot get a permissions answer it can act on: a sync
 * run that failed, a status write that never landed, or a first status read that
 * errored outright.
 *
 * Deliberately NOT shown for a run that is merely slow. In every case reached here,
 * no run holds ORCA's singleton key, so a refresh re-fires the trigger for real and
 * "refresh this page" is a true instruction rather than a platitude. A run still in
 * progress would discard that trigger and return the same reading, which is why it
 * keeps waiting instead — see WAIT_EXTENDED in {@link ./permissionSyncDecision}.
 *
 * Points at the LangHub team as the second step, because a refresh that keeps landing
 * back here is a backend problem the user has no further move against.
 *
 * Rendered as a Cloudscape error Alert by {@link ../../common/ui/StatusScreen}, in
 * place of the app at whatever URL the user is on, like
 * {@link ./ProfileUnavailablePage}, so the refresh lands them where they meant to be.
 */
const PermissionsUnavailablePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FailureStatus heading={t('auth-permissions-unavailable-heading')}>
      <p>{t('auth-permissions-unavailable-body')}</p>
    </FailureStatus>
  );
};

export default PermissionsUnavailablePage;
